import { render, staticRenderFns } from "./vue-list-item.vue?vue&type=template&id=6d28db2a&scoped=true&"
import script from "./vue-list-item.vue?vue&type=script&lang=js&"
export * from "./vue-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28db2a",
  null
  
)

export default component.exports